import { Component, OnInit } from '@angular/core';
import { AiUploadHistoryService } from '../../../services/ai-upload-history.service';
import {
  AiUploadHistory,
  AiUploadHistoryStats,
  AiUploadStatus,
} from '../../../models/ai-upload-history.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lib-ai-job-monitoring',
  templateUrl: './ai-job-monitoring.component.html',
  styleUrls: ['./ai-job-monitoring.component.scss'],
  standalone: false,
})
export class AiJobMonitoringComponent implements OnInit {

  items = [
    { label: 'AI.OVERVIEW', iconKey: 'ai-overview.svg', route: 'overview' },
    { label: 'AI.BATCH_IMAGE_IMPORT', iconKey: 'ai-bi.svg', route: 'batch-image-import' },
    { label: 'AI.AI_SEGMENTATION_LIST', iconKey: 'ai-sl.svg', route: 'segmentation-list' },
    { label: 'AI.JOB_MONITORING.TITLE', iconKey: 'ai-jm.svg', route: 'job-monitoring' }
  ];
  title = 'AI.TITLE_NEW';

  count: number = 0;
  pageSize = 10;
  currentPage: number = 1;
  AiUploadStatus = AiUploadStatus;
  stats!: AiUploadHistoryStats;
  histories: AiUploadHistory[] = [];

  constructor(
    private aiHistoryUploadService: AiUploadHistoryService,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.getStats();
    this.reloadTable();
  }

  onRowClick(historyUploadId: string) {
    //this.router.navigate(['ai/job-monitoring/edit', historyUploadId]);
  }

  onPageChange(currentPage: number) {
    this.currentPage = currentPage;
    this.reloadTable(currentPage);
  }

  reloadTable(page: number | null = null) {
    if (page) this.currentPage = page;
    let obj = {
      pageInfo: {
        page: this.currentPage,
        pageSize: this.pageSize,
      },
      filterParams: {
        
      },
    };
    this.getAll(obj);
  }
  private getAll(obj: any) {
    this.aiHistoryUploadService.getAllForJobMonitoring(obj).subscribe({
      next: (response: any) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.histories = responseData?.data?.data?.length
            ? responseData?.data?.data?.map(
                (el: any) => new AiUploadHistory(el)
              )
            : [];
          this.count = responseData.data.count ?? this.count;

          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  private getStats() {
    this.aiHistoryUploadService.getStats().subscribe({
      next: (response: any) => {
        const responseData = response.body;

        if (responseData?.status === 200 || responseData?.status === 'OK') {
          if (responseData?.data) {
            this.stats = new AiUploadHistoryStats(responseData.data);
          }

          if (responseData.message !== '') {
            this.toastr.warning(responseData.message);
          }
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: () => this.toastr.error('Error occurred'),
    });
  }

  getStatusLabel(history: AiUploadHistory): string {
    return history.uploadStatus === 'Completed' &&
      history.processingStatus === 'Completed'
      ? 'Completed'
      : 'In Progress';
  }

  getStatusColorClass(history: AiUploadHistory): string {
    return history.status === 'Completed' ? 'green' : 'orange';
  }
}
